import firebase from "firebase";

var config = {
  apiKey: "AIzaSyB5_8mWcxOZWG8EGUXfyDOJtj8u0HbYKH0",
  authDomain: "deuna-prototype.firebaseapp.com",
  databaseURL: "https://deuna-prototype.firebaseio.com",
  projectId: "deuna-prototype",
  storageBucket: "deuna-prototype.appspot.com",
  messagingSenderId: "694682709590"
};

var fire = firebase.initializeApp(config);

export default fire;



// WEBPACK FOOTER //
// ./src/Firebase/Firebase.js